import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import SignatureCanvas from 'react-signature-canvas';
import { Button, Icon } from 'semantic-ui-react';

import styles from './SignaturePad.module.scss';

const SignaturePad = React.memo(({ onChange, required }) => {
  const sigCanvas = useRef(null);
  const [isEmpty, setIsEmpty] = useState(true);

  const handleClear = () => {
    sigCanvas.current.clear();
    setIsEmpty(true);
    if (onChange) {
      onChange('');
    }
  };

  const handleEnd = () => {
    if (sigCanvas.current && !sigCanvas.current.isEmpty()) {
      setIsEmpty(false);
      const dataUrl = sigCanvas.current.toDataURL();
      if (onChange) {
        onChange(dataUrl);
      }
    }
  };

  return (
    <div className={styles.signatureContainer}>
      <div className={styles.canvasWrapper}>
        <SignatureCanvas
          ref={sigCanvas}
          penColor="black"
          canvasProps={{
            className: styles.signatureCanvas
          }}
          onEnd={handleEnd}
        />
        {isEmpty && (
          <div className={styles.placeholder}>
            <Icon name="pencil" size="large" />
            <p>Draw your signature here</p>
            {required && <small>Required</small>}
          </div>
        )}
      </div>

      <div className={styles.actions}>
        <Button
          type="button"
          size="small"
          basic
          onClick={handleClear}
          disabled={isEmpty}
        >
          <Icon name="eraser" />
          Clear
        </Button>
        {!isEmpty && (
          <div className={styles.signedIndicator}>
            <Icon name="check circle" color="green" />
            <span>Signed</span>
          </div>
        )}
      </div>
    </div>
  );
});

SignaturePad.propTypes = {
  onChange: PropTypes.func,
  required: PropTypes.bool,
};

SignaturePad.defaultProps = {
  onChange: null,
  required: false,
};

export default SignaturePad;
